<div class="card">
    <div class="py-2 px-3 d-flex flex-column">
        <img *ngIf="midwife.profileImage" [src]="midwife.profileImage" alt="" class="profile-img">
        <img *ngIf="!midwife.profileImage" src="../../../../assets/Images/pro-pic.png" alt="" class="profile-img">
        <span class="profile-name mt-2">{{midwife.name}}</span>
        <div class="row justify-content-center mt-3">
            <button class="profile-chip mr-2"><i class="fas fa-star mr-1 star"></i>{{midwife.rating}} <span class="text-muted">({{midwife.numReviews}})</span></button>
            <button class="profile-chip mr-2">{{midwife.experienceInYears}} years</button>
        </div>
    </div>
    <hr class="mx-0 mt-2 mb-0">
    <span class="view-profile" [routerLink]="['/profile', midwife.midwifeId]">View Profile</span>
</div>